import { IconCode } from "@multiweb/types/contracts";
import { ActionType } from "@multiweb/types/multiweb";
import { IEmptyMessage, ReactAction } from "@multiweb/types/react";

export const BASIC_ACTION_MOCK_ID = "0";
export const ICON_ACTION_MOCK_ID = "1";
export const DETAIL_ACTION_MOCK_ID = "2";
export const ACTIONS_LOCALIZATION_MOCK = {
    [`XG-${BASIC_ACTION_MOCK_ID}`]: { primaryText: "Basic action", secondaryText: "Basic action description" },
    [`XG-${ICON_ACTION_MOCK_ID}`]: { primaryText: "Icon action", secondaryText: "Icon action description" },
    [`XG-${DETAIL_ACTION_MOCK_ID}`]: { primaryText: "Detail action", secondaryText: "Detail action description" },
    ["XG-3"]: { primaryText: "Basic action 2", secondaryText: "Another basic action description" },
    ["XG-4"]: { primaryText: "Basic action 3", secondaryText: "Another basic action description" },
    ["XG-5"]: { primaryText: "Basic action 4", secondaryText: "Another basic action description" },
};
export const ACTIONS_MOCK: ReactAction[] = [
    {
        id: BASIC_ACTION_MOCK_ID,
        locKey: `XG-${BASIC_ACTION_MOCK_ID}`,
        text: "TextButton",
        actionType: ActionType.method,
        enabled: true,
        enabledVisual: true,
        order: 1,
        priority: 10,
        visible: true,
        isActive: true,
    },
    {
        id: ICON_ACTION_MOCK_ID,
        locKey: `XG-${ICON_ACTION_MOCK_ID}`,
        text: "TextButton",
        iconCode: IconCode.weatherWindsock,
        actionType: ActionType.method,
        enabled: true,
        enabledVisual: true,
        order: 2,
        priority: 5,
        visible: true,
        isActive: true,
    },
    {
        id: "3",
        locKey: "XG-3",
        text: "TextButton",
        iconCode: IconCode.editorialAlignCenter,
        actionType: ActionType.method,
        enabled: true,
        enabledVisual: true,
        order: 3,
        priority: 5,
        visible: true,
        isActive: true,
    },
    {
        id: "4",
        locKey: "XG-4",
        text: "TextButton",
        iconCode: IconCode.editorialAlignLeft,
        actionType: ActionType.method,
        enabled: true,
        enabledVisual: true,
        order: 4,
        priority: 5,
        visible: true,
        isActive: true,
    },
    {
        id: "5",
        locKey: "XG-5",
        text: "TextButton",
        iconCode: IconCode.editorialAlignRight,
        actionType: ActionType.method,
        enabled: true,
        enabledVisual: true,
        order: 5,
        priority: 5,
        visible: true,
        isActive: true,
    },
];

export const CLICKABLE_ROW_ACTION_MOCK: ReactAction[] = [
    {
        id: DETAIL_ACTION_MOCK_ID,
        locKey: `XG-${DETAIL_ACTION_MOCK_ID}`,
        text: "TextButton",
        actionType: ActionType.standardOpenDetail,
    },
];

export const MOCK_NAMES = [
    "Alois",
    "Adam",
    "Tomáš",
    "Petr",
    "Jiří",
    "Karel",
    "Jakub",
    "Pavel",
    "Jana",
    "Barbora",
    "Markéta",
    "Zuzana",
    undefined,
];
export const MOCK_ICONS = [
    IconCode.locationCompass,
    IconCode.locationDirection,
    IconCode.locationMap,
    IconCode.locationPin,
    IconCode.locationPinCheck,
    IconCode.locationPinMap,
    undefined,
];
export const MOCK_FLAGS = [
    "fRed",
    "fGreen",
    "fBlue",
    "fBlack",
    "fGray",
    "fSilver",
    "fYellow",
    "fBrown",
    "fLime",
    "fNavy",
    "fAqua",
    "fFuchsia",
    "fPink",
    "fDeepPurple",
    "fLightBlue",
    "fTeal",
    "fLightGreen",
    "fAmber",
    "fOrange",
    "fDeepOrange",
    undefined,
];
export const MOCK_DOCUMENT_NAMES = [
    "Document.pdf",
    "Attachment.txt",
    "Main file.pdf",
    "Random_file.txt",
];

export const ATTR_NAME = "Attr";
export const ICON_ATTR_NAME = "IconAttr";

export const EMPTY_MESSAGE_MOCK: IEmptyMessage = {
    text: "Žádné záznamy. V tomto seznamu nemáme co zobrazit.",
    iconCode: IconCode.docArchiveEmpty,
};
